import {
  DistributeContentRequest,
  DistributeContentResponse,
} from '@/client/types/admin/hubs/HubDistribution';
import {
  HubAccessChildResponse,
  HubExchangeCodeResponse,
} from '@/client/types/admin/hubs/HubAccess';
import {
  HubAdminGrantInput,
  HubRosterIdsResponse,
  HubRosterResponse,
} from '@/client/types/admin/hubs/HubRoster';
import { HubChildrenResponse } from '@/client/types/admin/hubs/HubChild';
import { hubApiClient } from './clients/hubApiClient';
import { preAuthApiClient } from './clients/preAuthApiClient';

const getHubChildren = async (): Promise<HubChildrenResponse> => {
  const response = await hubApiClient.get<HubChildrenResponse>('children');

  return response.data;
};

const accessChild = async (childCompanyId: string): Promise<HubAccessChildResponse> => {
  const response = await hubApiClient.post<HubAccessChildResponse>('access-child', {
    childCompanyId,
  });

  return response.data;
};

// Runs on the CHILD domain before any session exists. preAuthApiClient
// carries no auth header — a stale learner token on this origin must not
// ride along on the exchange.
const exchangeCode = async (code: string): Promise<HubExchangeCodeResponse> => {
  const response = await preAuthApiClient.post<HubExchangeCodeResponse>('/hub/exchange-code', {
    code,
  });

  return response.data;
};

const distribute = async (
  request: DistributeContentRequest,
): Promise<DistributeContentResponse> => {
  const response = await hubApiClient.post<DistributeContentResponse>('distribute', request);

  return response.data;
};

const getHubAdmins = async (): Promise<HubRosterResponse> => {
  const response = await hubApiClient.get<HubRosterResponse>('admins');

  return response.data;
};

const addHubAdmin = async (
  userId: string,
  grant: HubAdminGrantInput,
): Promise<HubRosterIdsResponse> => {
  const response = await hubApiClient.post<HubRosterIdsResponse>('admins', { userId, ...grant });

  return response.data;
};

const updateHubAdminGrant = async (
  userId: string,
  grant: HubAdminGrantInput,
): Promise<HubRosterIdsResponse> => {
  const response = await hubApiClient.patch<HubRosterIdsResponse>(`admins/${userId}`, grant);

  return response.data;
};

const removeHubAdmin = async (userId: string): Promise<HubRosterIdsResponse> => {
  const response = await hubApiClient.delete<HubRosterIdsResponse>(`admins/${userId}`);

  return response.data;
};

const HubService = {
  getHubChildren,
  accessChild,
  exchangeCode,
  distribute,
  getHubAdmins,
  addHubAdmin,
  updateHubAdminGrant,
  removeHubAdmin,
};

export default HubService;
